/**
 * Copyable request ID diagnostic chip (APP-001 §12).
 *
 * The backend `request_id` is the single safe diagnostic identifier surfaced to
 * users. It is never a secret, never an idempotency key, and never contains
 * PII. It is shown copyable so users can include it in support requests.
 */
import { CopyButton } from '@/components/sensitive/CopyButton';
import { cn } from '@/lib/utils';

export function RequestId({ requestId, className }: { requestId?: string; className?: string }) {
  if (!requestId) return null;
  return (
    <div className={cn('inline-flex items-center gap-2 rounded-md border bg-surface-muted px-2 py-1', className)}>
      <span className="text-xs text-muted-foreground">Request ID</span>
      <code className="font-mono text-xs text-foreground">{requestId}</code>
      <CopyButton value={requestId} label="Copy request ID" successMessage="Request ID copied" />
    </div>
  );
}
